const farmerSidebar = [
    {
      link: "/FarmerDashboard",
      icon: "dashboard",
      name:"Dashboard",
    },
    {
        link: "/GrowBot",
        icon: "bot",
        name:"GrowBot",
    },
    {
        link: "/DiseaseDetect",
        icon: "disease",
        name:"Disease Detection",
    },
    {
        link: "/AutomatedDisease",
        icon: "disease",
        name:"Automated Disease Detection",
    },
    {
        link: "/SpaceMapping",
        icon: "mapping",
        name:"Space Mapping",
    },
    {
        link: "/CropForecast",
        icon: "crop",
        name:"Crop Yielding Prediction",
    },
    {
        link: "/Forum",
        icon: "forum",
        name:"Forum",
    },
    {
        link: "/ClassesEvents",
        icon: "class",
        name:"Classes and Events",
    },
    {
        link: "/Market",
        icon: "market",
        name:"Marketplace",
    },
  ];

  export default farmerSidebar;